import { createSelector } from 'selectors'
import { help } from './constant'

export const getForm = () => createSelector<HTMLElement>({ selector: help.selector.form })

const getCheckbox = (scope?: HTMLElement) =>
	createSelector<HTMLInputElement>({ scope, selector: help.selector.checkbox })

const getTranslationInput = (scope?: HTMLElement) =>
	Array.from(createSelector<NodeListOf<HTMLInputElement>>({ scope, selector: help.selector.inputs }, true)).find((e) =>
		Array.from(e.children).find((c) => c.matches(help.selector.translationInput)),
	)

export const getHelpComponents = () => {
	const form = getForm()
	return {
		checkbox: getCheckbox(form),
		translationInput: getTranslationInput(form),
	}
}
